import { gql } from '@urql/core';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Time: { input: string; output: string };
};

export type AccessControlEntry = {
  __typename?: 'AccessControlEntry';
  accessRule: AccessRule;
  accessType: AccessType;
  entityWithAccess: AccessorEntity;
  grantedBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AccessControlEntryInput = {
  accessRule: AccessRule;
  entityWithAccess: AccessorEntityInput;
};

export type AccessResource = Node & {
  __typename?: 'AccessResource';
  accessControlList: Array<AccessControlEntry>;
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  resourceId: Scalars['ID']['output'];
  type: AccessResourceType;
};

export type AccessResourceInput = {
  resourceId: Scalars['ID']['input'];
  type: AccessResourceType;
};

export enum AccessResourceType {
  Page = 'PAGE',
}

export enum AccessRule {
  Full = 'FULL',
  Read = 'READ',
  Write = 'WRITE',
}

export enum AccessType {
  Allow = 'ALLOW',
  Deny = 'DENY',
}

export type AccessorEntity = {
  __typename?: 'AccessorEntity';
  id: Scalars['String']['output'];
  type: AccessorEntityType;
};

export type AccessorEntityInput = {
  id: Scalars['String']['input'];
  type: AccessorEntityType;
};

export enum AccessorEntityType {
  User = 'USER',
  UserGroup = 'USER_GROUP',
}

export type AccountBalance = {
  __typename?: 'AccountBalance';
  asset: Asset;
  balance: Scalars['Float']['output'];
  locked: Scalars['Boolean']['output'];
};

export type AddControlEntryInput = {
  accessRule: AccessRule;
  accessType: AccessType;
  accessor: AccessorEntityInput;
  resourceId: Scalars['ID']['input'];
  resourceType: AccessResourceType;
};

export type Asset = {
  __typename?: 'Asset';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum AssetCode {
  Ghs = 'GHS',
  Usd = 'USD',
}

export type AuthenticatedUser = {
  __typename?: 'AuthenticatedUser';
  createdAt: Scalars['Time']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasSuperPermission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgs?: Maybe<Array<Org>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
};

export type AuthenticatedUserOrgsArgs = {
  orgSlug?: InputMaybe<Scalars['String']['input']>;
};

export type BasicResponse = {
  __typename?: 'BasicResponse';
  success: Scalars['Boolean']['output'];
};

export type BasicTransactionResponse = {
  __typename?: 'BasicTransactionResponse';
  status: TransactionStatus;
  transactionId?: Maybe<Scalars['String']['output']>;
  txRef: Scalars['String']['output'];
};

export enum BusinessType {
  Corporation = 'CORPORATION',
  Llc = 'LLC',
  NonProfit = 'NON_PROFIT',
  Other = 'OTHER',
  Partnership = 'PARTNERSHIP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
}

export enum CollectionOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type CreateAccessResourceInput = {
  parentId?: InputMaybe<Scalars['Int']['input']>;
  resourceId: Scalars['ID']['input'];
  type: AccessResourceType;
};

export type CreateOrgInput = {
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrgKycInput = {
  businessType: BusinessType;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  legalEntityName: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};

export type CreateStoreInput = {
  location: LocationInput;
  name: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};

export type CreateUserKycInput = {
  age: Scalars['Int']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  legalFullName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export enum EntityType {
  Org = 'ORG',
  User = 'USER',
}

export type Fees = {
  __typename?: 'Fees';
  breakdown: Array<Fees>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
};

export type FundAccountRequest = {
  amount: Scalars['Float']['input'];
  assetId: Scalars['Int']['input'];
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
  txRef: Scalars['String']['input'];
};

export type GeneralSettings = {
  __typename?: 'GeneralSettings';
  defaultCurrencyISOCode: Scalars['String']['output'];
};

export type IdRequirement = {
  __typename?: 'IdRequirement';
  condition: RequirementCondition;
  idTypes?: Maybe<Array<IdentificationType>>;
};

export type IdRequirementRequest = {
  businessType: BusinessType;
  country: Scalars['String']['input'];
  entityType: EntityType;
};

export type IdentificationDocument = {
  __typename?: 'IdentificationDocument';
  documentUrl: Scalars['String']['output'];
  entityID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  idType: IdentificationType;
  status: VerificationStatus;
};

export enum IdentificationType {
  BusinessRegistrationDocuments = 'BUSINESS_REGISTRATION_DOCUMENTS',
  DriversLicense = 'DRIVERS_LICENSE',
  EcowasId = 'ECOWAS_ID',
  GhanaCard = 'GHANA_CARD',
  NationalId = 'NATIONAL_ID',
  NationalIdNonCitizen = 'NATIONAL_ID_NON_CITIZEN',
  Passport = 'PASSPORT',
  ResidencePermit = 'RESIDENCE_PERMIT',
  RwandaCard = 'RWANDA_CARD',
  Ssn = 'SSN',
  Ssnit = 'SSNIT',
  TaxIdentificationNumber = 'TAX_IDENTIFICATION_NUMBER',
  TravelDocument = 'TRAVEL_DOCUMENT',
  VoterId = 'VOTER_ID',
}

export type InviteResourceInput = {
  accessResource: AccessResourceInput;
  accessRule: AccessRule;
  email: Scalars['String']['input'];
};

export type InviteRoleInput = {
  email: Scalars['String']['input'];
  role: OrgRole;
};

export enum LedgerRole {
  DistributionAccount = 'DISTRIBUTION_ACCOUNT',
  FeeCollectionAccount = 'FEE_COLLECTION_ACCOUNT',
  FeePayingAccount = 'FEE_PAYING_ACCOUNT',
  IssuerAccount = 'ISSUER_ACCOUNT',
  SequenceBumpAccount = 'SEQUENCE_BUMP_ACCOUNT',
}

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LogoDownloadSignedUrlResponse = {
  __typename?: 'LogoDownloadSignedUrlResponse';
  signedUrl: Scalars['String']['output'];
};

export type LogoUploadSignedUrlResponse = {
  __typename?: 'LogoUploadSignedUrlResponse';
  logoPath: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type MinimumDepositAmount = {
  __typename?: 'MinimumDepositAmount';
  amount: Scalars['Float']['output'];
  assetId: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addControlEntries: Array<AccessResource>;
  createAccessResources: Array<AccessResource>;
  createOrgKyc?: Maybe<BasicResponse>;
  createStore: BasicResponse;
  createUserKyc?: Maybe<BasicResponse>;
  deleteStores: BasicResponse;
  fundAccount: PaymentLinkResponse;
  generateLogoDownloadSignedUrl?: Maybe<LogoDownloadSignedUrlResponse>;
  generateLogoUploadSignedUrl?: Maybe<LogoUploadSignedUrlResponse>;
  initiatePayout: BasicTransactionResponse;
  logout?: Maybe<BasicResponse>;
  orgCreate?: Maybe<Org>;
  orgInviteUserToResource: Array<UserInvite>;
  orgInviteUserToRole: Array<UserInvite>;
  removeControlEntries: Array<AccessResource>;
  removeInvitedUser?: Maybe<BasicResponse>;
  removeOrgUser?: Maybe<BasicResponse>;
  saveOrgLogo?: Maybe<BasicResponse>;
  transfer: BasicTransactionResponse;
  updateOrgKyc?: Maybe<BasicResponse>;
  updateStore: BasicResponse;
  updateUserKyc?: Maybe<BasicResponse>;
  updateUserOrgRole?: Maybe<BasicResponse>;
};

export type MutationAddControlEntriesArgs = {
  controlEntries: Array<AddControlEntryInput>;
  orgId: Scalars['ID']['input'];
};

export type MutationCreateAccessResourcesArgs = {
  orgId: Scalars['ID']['input'];
  resources: Array<CreateAccessResourceInput>;
};

export type MutationCreateOrgKycArgs = {
  input: CreateOrgKycInput;
};

export type MutationCreateStoreArgs = {
  input: CreateStoreInput;
};

export type MutationCreateUserKycArgs = {
  input: CreateUserKycInput;
};

export type MutationDeleteStoresArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type MutationFundAccountArgs = {
  request: FundAccountRequest;
};

export type MutationGenerateLogoDownloadSignedUrlArgs = {
  logoPath: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};

export type MutationGenerateLogoUploadSignedUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};

export type MutationInitiatePayoutArgs = {
  request: PayoutRequest;
};

export type MutationOrgCreateArgs = {
  input: CreateOrgInput;
};

export type MutationOrgInviteUserToResourceArgs = {
  invites: Array<InviteResourceInput>;
  orgId: Scalars['ID']['input'];
};

export type MutationOrgInviteUserToRoleArgs = {
  invites: Array<InviteRoleInput>;
  orgId: Scalars['ID']['input'];
};

export type MutationRemoveControlEntriesArgs = {
  controlEntries: Array<RemoveControlEntryInput>;
  orgId: Scalars['ID']['input'];
};

export type MutationRemoveInvitedUserArgs = {
  email: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};

export type MutationRemoveOrgUserArgs = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationSaveOrgLogoArgs = {
  logoPath: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
};

export type MutationTransferArgs = {
  request: TransferRequest;
};

export type MutationUpdateOrgKycArgs = {
  input: UpdateOrgKycInput;
};

export type MutationUpdateStoreArgs = {
  input: UpdateStoreInput;
};

export type MutationUpdateUserKycArgs = {
  input: UpdateUserKycInput;
};

export type MutationUpdateUserOrgRoleArgs = {
  orgId: Scalars['ID']['input'];
  role: OrgRole;
  userId: Scalars['ID']['input'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Org = {
  __typename?: 'Org';
  createdAt: Scalars['Time']['output'];
  generalSettings: GeneralSettings;
  id: Scalars['ID']['output'];
  invitedUsers?: Maybe<Array<UserInvite>>;
  isActive: Scalars['Boolean']['output'];
  isRestricted: Scalars['Boolean']['output'];
  kyc?: Maybe<OrgKyc>;
  logoMimeType?: Maybe<Scalars['String']['output']>;
  logoPath?: Maybe<Scalars['String']['output']>;
  logoSize?: Maybe<Scalars['Int']['output']>;
  logoUploadedAt?: Maybe<Scalars['Time']['output']>;
  logoUploadedByUserID?: Maybe<Scalars['String']['output']>;
  myOrgRole: OrgRole;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  users?: Maybe<Array<OrgUser>>;
};

export type OrgKyc = {
  __typename?: 'OrgKyc';
  businessType: BusinessType;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  idDocs: Array<IdentificationDocument>;
  legalEntityName: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  status: VerificationStatus;
};

export enum OrgRole {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  Member = 'MEMBER',
  Owner = 'OWNER',
}

export type OrgUser = {
  __typename?: 'OrgUser';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgRole: OrgRole;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
};

export type PaymentLinkResponse = {
  __typename?: 'PaymentLinkResponse';
  link: Scalars['String']['output'];
  processor: PaymentProcessor;
};

export enum PaymentProcessor {
  Paystack = 'PAYSTACK',
  Sidejuice = 'SIDEJUICE',
}

export enum PaymentReason {
  FundAccount = 'FUND_ACCOUNT',
  Purchase = 'PURCHASE',
}

export type PaymentRecipient = {
  percent: Scalars['Float']['input'];
  recipientId: Scalars['ID']['input'];
};

export type PayoutRequest = {
  amount: Scalars['Float']['input'];
  assetId: Scalars['Int']['input'];
  country: Scalars['String']['input'];
  senderId: Scalars['ID']['input'];
  txRef: Scalars['String']['input'];
};

export type PreviewPayoutFeesResponse = {
  __typename?: 'PreviewPayoutFeesResponse';
  fees: Fees;
};

export type PreviewTransferFeesResponse = {
  __typename?: 'PreviewTransferFeesResponse';
  fees: Fees;
  paymentLink?: Maybe<PaymentLinkResponse>;
};

export type Query = {
  __typename?: 'Query';
  accessResources: Array<AccessResource>;
  balances: Array<AccountBalance>;
  idRequirements: Array<IdRequirement>;
  me?: Maybe<User>;
  org?: Maybe<Org>;
  payoutFees: PreviewPayoutFeesResponse;
  stores: Array<Store>;
  transferFees: PreviewTransferFeesResponse;
};

export type QueryAccessResourcesArgs = {
  orgId: Scalars['ID']['input'];
};

export type QueryBalancesArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryIdRequirementsArgs = {
  input: IdRequirementRequest;
};

export type QueryOrgArgs = {
  orgId: Scalars['ID']['input'];
};

export type QueryPayoutFeesArgs = {
  request: PayoutRequest;
};

export type QueryStoresArgs = {
  orgId: Scalars['ID']['input'];
};

export type QueryTransferFeesArgs = {
  request: TransferRequest;
};

export type RemoveControlEntryInput = {
  accessor: AccessorEntityInput;
  resourceId: Scalars['ID']['input'];
  resourceType: AccessResourceType;
};

export enum RequirementCondition {
  AllOf = 'ALL_OF',
  AnyOf = 'ANY_OF',
}

export type SenderAccount = {
  amount: Scalars['Float']['input'];
  senderId: Scalars['ID']['input'];
};

export enum SignerSecurityLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type Store = {
  __typename?: 'Store';
  id: Scalars['ID']['output'];
  location: Location;
  name?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['ID']['output'];
};

export enum TransactionStatus {
  AlreadyProcessed = 'ALREADY_PROCESSED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN',
}

export enum TransactionType {
  Deposit = 'DEPOSIT',
  Mint = 'MINT',
  Payout = 'PAYOUT',
  Refund = 'REFUND',
  Transfer = 'TRANSFER',
  Withdraw = 'WITHDRAW',
}

export type TransferRequest = {
  amount: Scalars['Float']['input'];
  assetId: Scalars['Int']['input'];
  country: Scalars['String']['input'];
  recipients: Array<PaymentRecipient>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  source: Array<SenderAccount>;
  txRef: Scalars['String']['input'];
};

export type UpdateOrgKycInput = {
  businessType?: InputMaybe<BusinessType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
};

export type UpdateStoreInput = {
  id: Scalars['ID']['input'];
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserKycInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  legalFullName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type User = Node & {
  __typename?: 'User';
  authenticatedUser?: Maybe<AuthenticatedUser>;
  createdAt: Scalars['Time']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasSuperPermission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  kyc?: Maybe<UserKyc>;
  name: Scalars['String']['output'];
  orgs?: Maybe<Array<Org>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
};

export type UserOrgsArgs = {
  orgSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  accessResource?: Maybe<AccessResource>;
  accessRule?: Maybe<AccessRule>;
  createdAt: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  invitedByUser?: Maybe<User>;
  role?: Maybe<OrgRole>;
};

export type UserKyc = {
  __typename?: 'UserKyc';
  age: Scalars['Int']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  idDocs: Array<IdentificationDocument>;
  legalFullName: Scalars['String']['output'];
  status: VerificationStatus;
  userId: Scalars['ID']['output'];
};

export enum VerificationStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Verified = 'VERIFIED',
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = {
  __typename?: 'Mutation';
  logout?: { __typename?: 'BasicResponse'; success: boolean } | null;
};

export type OrgCreateMutationVariables = Exact<{
  input: CreateOrgInput;
}>;

export type OrgCreateMutation = {
  __typename?: 'Mutation';
  orgCreate?: {
    __typename?: 'Org';
    id: string;
    name: string;
    slug: string;
    isActive: boolean;
  } | null;
};

export type UserInviteFragmentFragment = {
  __typename?: 'UserInvite';
  email: string;
  role?: OrgRole | null;
  accessRule?: AccessRule | null;
  createdAt: string;
  invitedByUser?: { __typename?: 'User'; id: string } | null;
};

export type MeQueryVariables = Exact<{
  orgSlug?: InputMaybe<Scalars['String']['input']>;
}>;

export type MeQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    id: string;
    name: string;
    email?: string | null;
    phoneNumber?: string | null;
    createdAt: string;
    profileImage?: string | null;
    isAnonymous: boolean;
    authenticatedUser?: {
      __typename?: 'AuthenticatedUser';
      id: string;
      name: string;
      email?: string | null;
      phoneNumber?: string | null;
      createdAt: string;
      profileImage?: string | null;
      isAnonymous: boolean;
      orgs?: Array<{
        __typename?: 'Org';
        id: string;
        createdAt: string;
        name: string;
        slug: string;
        isActive: boolean;
      }> | null;
    } | null;
    orgs?: Array<{
      __typename?: 'Org';
      id: string;
      createdAt: string;
      name: string;
      slug: string;
      isActive: boolean;
      myOrgRole: OrgRole;
      logoPath?: string | null;
      users?: Array<{
        __typename?: 'OrgUser';
        id: string;
        name: string;
        profileImage?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        orgRole: OrgRole;
      }> | null;
      invitedUsers?: Array<{
        __typename?: 'UserInvite';
        email: string;
        role?: OrgRole | null;
        accessRule?: AccessRule | null;
        createdAt: string;
        invitedByUser?: { __typename?: 'User'; id: string } | null;
      }> | null;
      generalSettings: { __typename?: 'GeneralSettings'; defaultCurrencyISOCode: string };
    }> | null;
  } | null;
};

export const UserInviteFragmentFragmentDoc = gql`
  fragment UserInviteFragment on UserInvite {
    email
    role
    accessRule
    invitedByUser {
      id
    }
    createdAt
  }
`;
export const LogoutDocument = gql`
  mutation logout {
    logout {
      success
    }
  }
`;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
}
export const OrgCreateDocument = gql`
  mutation orgCreate($input: CreateOrgInput!) {
    orgCreate(input: $input) {
      id
      name
      slug
      isActive
    }
  }
`;

export function useOrgCreateMutation() {
  return Urql.useMutation<OrgCreateMutation, OrgCreateMutationVariables>(OrgCreateDocument);
}
export const MeDocument = gql`
  query me($orgSlug: String) {
    me {
      id
      name
      email
      phoneNumber
      createdAt
      profileImage
      isAnonymous
      authenticatedUser {
        id
        name
        email
        phoneNumber
        createdAt
        profileImage
        isAnonymous
        orgs(orgSlug: $orgSlug) {
          id
          createdAt
          name
          slug
          isActive
        }
      }
      orgs(orgSlug: $orgSlug) {
        id
        createdAt
        name
        slug
        isActive
        users {
          id
          name
          profileImage
          email
          phoneNumber
          orgRole
        }
        invitedUsers {
          ...UserInviteFragment
        }
        myOrgRole
        generalSettings {
          defaultCurrencyISOCode
        }
        logoPath
      }
    }
  }
  ${UserInviteFragmentFragmentDoc}
`;

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, 'query'>) {
  return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options });
}
